import { api } from 'app/utils/api/helpers'

export const listEmailLogs = (teamId: string, params: any) => {
  return api.get(`/sm/team/${teamId}/email/report`, { params })
}
